import React, { useEffect, useState } from 'react';
import { adminAPI } from '../services/api';
import { format } from 'date-fns';
import { ArrowsRightLeftIcon, MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import badgeSwap from '../assets/icons/badge-swap.png';
import badgeGift from '../assets/icons/badge-gift.png';
import badgeClock from '../assets/icons/badge-clock.png';
import KPICard from '../components/KPICard';
import styles from './ReferralsPage.module.css';

export default function ReferralsPage() {
  const [data,    setData]    = useState(null);
  const [loading, setLoading] = useState(true);
  const [search,  setSearch]  = useState('');

  useEffect(() => {
    adminAPI.getReferrals()
      .then(setData)
      .catch(console.error)
      .finally(() => setLoading(false));
  }, []);

  const referrals = data?.referrals || [];
  const ov = data?.overview || {};
  const fmtDate = d => { try { return format(new Date(d), 'dd MMM yyyy'); } catch { return '—'; } };

  const filtered = referrals.filter(r => {
    const q = search.toLowerCase();
    return !q ||
      `${r.referrer_first} ${r.referrer_last}`.toLowerCase().includes(q) ||
      r.referral_code?.toLowerCase().includes(q) ||
      r.referred_mobile?.includes(q);
  });

  return (
    <div>
      <div className="page-header">
        <div><h1>Referrals</h1><p>{(ov.totalReferrals||0).toLocaleString()} qualifying referrals</p></div>
      </div>

      <div className={styles.kpiRow}>
        <KPICard label="Total Referrals"   value={ov.totalReferrals||0}   badge={badgeSwap}  color="#2B9DD4" />
        <KPICard label="Rewards Issued"    value={ov.rewardedReferrals||0} badge={badgeGift}  color="#10B981" />
        <KPICard label="Pending"           value={ov.pendingReferrals||0}  badge={badgeClock} color="#F59E0B" />
      </div>

      <div className={styles.filters}>
        <div className={styles.searchBox}>
          <MagnifyingGlassIcon style={{ width:15, height:15, color:'var(--text-muted)' }} />
          <input className={styles.searchInput} placeholder="Search by referrer, code or mobile…" value={search} onChange={e=>setSearch(e.target.value)} />
        </div>
      </div>

      <div className="card" style={{ padding:0, overflow:'hidden' }}>
        <div className="table-wrap" style={{ border:'none', borderRadius:0 }}>
          <table className="data-table">
            <thead><tr><th>Referrer</th><th>Referral Code</th><th>Referred</th><th>Registered</th><th>Rewarded</th><th>Date</th></tr></thead>
            <tbody>
              {loading ? Array.from({length:6}).map((_,i)=>(
                <tr key={i}>{[150,120,120,80,80,100].map((w,j)=><td key={j}><div className="skeleton" style={{height:14,width:w,borderRadius:5}}/></td>)}</tr>
              )) : filtered.length===0 ? (
                <tr><td colSpan={6}><div className="empty-state"><ArrowsRightLeftIcon style={{width:28,height:28}}/><h3>No referrals found</h3></div></td></tr>
              ) : filtered.map((r,i)=>(
                <tr key={i}>
                  <td><div style={{fontWeight:600,fontSize:13}}>{r.referrer_first} {r.referrer_last}</div></td>
                  <td><span className={styles.code}>{r.referral_code}</span></td>
                  <td style={{fontSize:12,color:'var(--text-muted)',fontFamily:'monospace'}}>{r.referred_mobile}</td>
                  <td>{r.registration_confirmed ? <span className="badge badge-active">Yes</span> : <span className="badge badge-pending">No</span>}</td>
                  <td>{r.reward_issued ? <span className="badge badge-active">Yes</span> : <span className="badge badge-inactive">No</span>}</td>
                  <td style={{fontSize:12,color:'var(--text-muted)'}}>{fmtDate(r.created_at)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
